import { useEffect, useState } from 'react';

import { GetSessionVideo } from '@/connection/content/videos';
import { StaticVideo } from '@/types/video.types';
import toastTrigger from '@ui/toast/toast-trigger';
import { EToastTypes } from '@ui/toast/toast.types';

const useGetSessionVideo = (channel: number | null, videoUuid: string | null, sessionUuid?: string) => {
  const [sessionVideoData, setSessionVideoData] = useState<StaticVideo | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setSessionVideoData(null);
  }, [sessionUuid]);

  useEffect(() => {
    if (!channel || !videoUuid) {
      setSessionVideoData(null);
      return;
    }

    setLoading(true);

    (async () => {
      try {
        const result = await GetSessionVideo(channel, videoUuid);
        setSessionVideoData(result);
      } catch (error) {
        console.error('Error fetching session video:', error);
        toastTrigger('Error loading session video', {
          type: EToastTypes.error,
        });
      } finally {
        setLoading(false);
      }
    })();
  }, [channel, videoUuid]);

  return { sessionVideoData, loading };
};

export default useGetSessionVideo;
